import React from 'react';
import PropTypes from 'prop-types';

const Buttons = props => (
  <section className="module-filter top">
    <div className="flex">
      <div className="flex filter-box">
        <h2 id="select-filter" className="container-filter-h2 column-filter">
          <span>{props.language.account.accountExtendedProperty.filter.show}:</span>
          {props.selectedFilter !="" ? 
            props.language.account.accountExtendedProperty.filter[props.selectedFilter] : 
            props.language.account.accountExtendedProperty.filter.allProperties}
        </h2>
        <ul className="container-filter-ul">
          <li className="container-filter-li">
            <i className="fas fa-caret-down" />
            <ul>
              <li data-select="" onClick={props.handleFilter}>
                {props.language.account.accountExtendedProperty.filter.allProperties}
              </li>
              <li data-select="person" onClick={props.handleFilter}>
                {props.language.account.accountExtendedProperty.filter.person}
              </li>
              <li data-select="vehicle" onClick={props.handleFilter}>
                {props.language.account.accountExtendedProperty.filter.vehicle}
              </li>
              <li data-select="semiTrailer" onClick={props.handleFilter}>
                {props.language.account.accountExtendedProperty.filter.semiTrailer}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <div className="box-form">
        {props.buttonShow && (
          <ul className="buttom_menu">
            <li>
              <a data-close="ok" onClick={props.handleModal}>
                {props.language.account.accountExtendedProperty.buttons.createExtendedProperty}
              </a>
            </li>
          </ul>
        )}
      </div>
    </div>
  </section>
);

export default Buttons;



// WEBPACK FOOTER //
// ./source/client/components/account_extended_property/buttons.jsx